import { ChevronLeft, ChevronRight } from 'pcln-icons';
import React from 'react';
import { Button } from '../Button/Button';
import { Relative } from '../Relative/Relative';
import { ARROW_SIZES } from './Arrow.styled';
export function Arrow({
  isLeft,
  arrowButtonVariation,
  size,
  leftArrowClick,
  rightArrowClick,
  leftDisabled,
  rightDisabled,
  ...props
}) {
  const Icon = isLeft ? ChevronLeft : ChevronRight;
  const {
    buttonSize,
    iconSize
  } = ARROW_SIZES[size];
  return React.createElement(Relative, {
    zIndex: 99
  }, React.createElement(Button, {
    p: 0,
    variation: arrowButtonVariation,
    onClick: isLeft ? leftArrowClick : rightArrowClick,
    height: buttonSize,
    width: buttonSize,
    boxShadowSize: 'md',
    disabled: isLeft ? leftDisabled : rightDisabled,
    ...props
  }, React.createElement(Icon, {
    size: iconSize,
    pl: isLeft ? 0 : 1,
    pr: isLeft ? 1 : 0
  })));
}